import { inputChangehandlers } from "../../helpers/formHandlers";
import {
  Button,
  Container,
  IsRequiredStar,
  Label,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";

const optionCntMbStyle = css`
  flex-direction: column;
  align-self: start;
  gap: 1vh;
`;
const cntStyle = (displayDir) => css`
  flex-direction: ${displayDir ? "column" : "row"};
  gap: 1vh;
`;
const optionBttn = css`
  justify-content: flex-start;
  gap: 0.5vh;
  font-size: 1.5vh;
`;
const bttnCircle = css`
  border: 1px solid ${({ theme }) => theme.secColor};
  border-radius: 50%;
  width: 2vh;
  height: 2vh;
  align-items: center;
  justify-content: center;
`;
const circleFill = (fill) => css`
  background-color: ${({ theme }) => fill && theme.main};
  border-radius: 50%;
  width: 1.5vh;
  height: 1.5vh;
`;
const gapSize = css`
gap:1vh;
`

const OptionsInput = ({ properties, setForm, index, isColumn}) => {
  const {
    options,
    value,
    label,
    required,
    onChangeHandler,
    handleValidation,
  } = properties;

  const handleChange = (option) => {
    if (option === value) return;
    const handler = inputChangehandlers[onChangeHandler];
    if (handler) {
      handler(setForm, index, option);
    }
    const validationHandler = inputChangehandlers[handleValidation];
    if (validationHandler) {
      validationHandler(setForm, properties, index, option);
    }
  };


  return (
    <Container $baseStyle={gapSize} $mStyle={optionCntMbStyle}>
      {label && (
        <Label>
          {label}
          {required && <IsRequiredStar />}
        </Label>
      )}
      <Container $baseStyle={cntStyle(isColumn)}>
        {options?.map((option) => (
          <Button
            key={option}
            id={option}
            type="button"
            $baseStyle={optionBttn}
            onClick={() => handleChange(option)}
          >
            <Container $baseStyle={bttnCircle}>
              <Container $baseStyle={circleFill(value === option)} />
            </Container>
            {option}
          </Button>
        ))}
      </Container>
    </Container>
  );
};

export default OptionsInput;
